import {
  APP_ERROR_TYPE,
  useAppErrorHandler,
  useUserContext,
} from '@issuemanager/apps/client/contexts';
import { useAdmin } from '@issuemanager/apps/client/hooks';
import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface Props {
  redirectPath: string;
}

export function AdminOrTypeManagerRoute({ redirectPath }: Props) {
  const isAdmin = useAdmin();
  const { userRoles } = useUserContext();
  const appErrorHandler = useAppErrorHandler();

  const hasManagedIssueTypes = userRoles?.hasManagedIssueTypes ?? false;

  const notAdminOrIssueManager = !isAdmin && !hasManagedIssueTypes;

  useEffect(() => {
    if (userRoles && notAdminOrIssueManager) {
      appErrorHandler.setError({ type: APP_ERROR_TYPE.FORBIDDEN });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notAdminOrIssueManager]);

  if (!userRoles) {
    return null;
  }

  if (notAdminOrIssueManager) {
    return <Navigate to={redirectPath} />;
  }

  return <Outlet />;
}
